<template>
  <v-container class="confirm-offer-campaign py-0 px-0" fluid>
    <v-row no-gutters>
      <v-col cols="9" class="pr-1 products-offer-confirm">
        <mf-info-card
          v-if="automaticCampaign"
          class="mb-3"
          variant="warning"
          description="Esta campanha foi importada automaticamente do seu ERP. As edições dessas ofertas serão sobrescritas na próxima carga de ofertas."
        />
        <mf-card-container title="Lojas participantes:">
          <v-chip v-for="unit in units" :key="unit.id" class="mr-1 mb-1">
            {{ unit.name }}
          </v-chip>

          <div v-if="hasCashbackOffer" class="cashback-expiration-container">
            <h2>Expiração de cashback</h2>
            <p v-html-safe="cashbackOfferLabel" />
          </div>
        </mf-card-container>

        <mf-card-container
          v-if="isFranchise"
          class="mt-3 mr-1"
          title="Presença dos produtos nos franqueados"
          description="Do total de EANs adicionados nessa oferta, quantos estão presentes em cada uma das lojas selecionadas."
        >
          <template v-slot:headers>
            <export-email-report-dialog
              title="Relatório - Presença de produtos nos franqueados"
              description="O relatório é enviado, através de um e-mail, para a caixa de entrada de todos os endereções de e-mail adicionados abaixo. O relatório em questão detalha toda a relação de produtos que estão na campanha com os respectivos franqueados que não contém esse produto em sua base."
              async
              :disabled="loadingFranchiseeProducts"
              :export-report-fn="exportReport"
              @file-format="getFileFormat"
            />
          </template>

          <mf-loading :boolean-loader="loadingFranchiseeProducts" loader-type="dynamic" :dynamic-amount="1" :dynamic-width="400">
            <div class="d-flex align-center custom-progress-bar mt-5">
              <mf-progress-bar
                :color="getProductsPercentageColor"
                :partial-value="franchiseeEansFrequencyPercentage"
                :total-value="100"
                hide-legend
                hide-percentage
              />
              <p :style="`color: ${getProductsPercentageColor}`" class="ml-2 my-0">{{ franchiseeEansFrequencyPercentage | localeString(1) | percent }}</p>
            </div>
          </mf-loading>
        </mf-card-container>
        <v-row no-gutters class="mt-2">
          <v-col v-for="offerSale in offerSalesTable" :key="offerSale" cols="12" class="mb-4">
            <revision-container :campaign="campanha" :offer-sales-type="offerSale" />
          </v-col>
          <v-col v-if="campanha.combo_offer_sales && campanha.combo_offer_sales.length" cols="12" class="mb-4">
            <confirm-campaign-offer-combo-table :offer-combo="campanha.combo_offer_sales" :eans="eans" :campaign="campanha" />
          </v-col>
          <v-col v-if="campanha.dynamic_rule_offer_sales && campanha.dynamic_rule_offer_sales.length" cols="12" class="mb-4">
            <digital-voucher-table :campaign="campanha" :disabled="true" :tooltip-message="tooltipEditMercapromoStatus" />
          </v-col>
          <v-col v-if="campanha.cross_sell_offer_sales && campanha.cross_sell_offer_sales.length" cols="12" class="mb-4">
            <cross-sell-table :campaign="campanha" :disabled="true" :tooltip-message="tooltipEditMercapromoStatus" />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="3" class="pl-1">
        <div class="sticky">
          <v-row no-gutters>
            <v-col>
              <v-card class="mb-2">
                <v-card-title class="pb-0">
                  <b>{{ campanha.name }}</b>
                </v-card-title>
                <v-card-text>
                  {{ campanha.description }}
                </v-card-text>

                <v-card-title class="sub-title py-0"> Período de validade: </v-card-title>
                <v-card-text>
                  {{ DateTime.fromISO(campanha.start_date).toFormat('dd/MM/yyyy') }} até {{ DateTime.fromISO(campanha.end_date).toFormat('dd/MM/yyyy') }}
                </v-card-text>
                <v-card-title class="sub-title py-0"> Tipo de campanha: </v-card-title>
                <v-card-text v-if="campanha.segments.length > 0 && !isIntelligentDistributionEnabled">
                  <strong class="confirm-bold">Personalizada</strong> - Apenas para as pessoas dos segmentos abaixo:
                  <div>
                    <v-chip v-for="segment in campanha.segments" :key="segment._id" class="my-1 mx-1">
                      {{ segment.name }}
                    </v-chip>
                  </div>
                </v-card-text>
                <v-card-text v-else-if="isIntelligentDistributionEnabled">
                  <strong class="confirm-bold">Distribuição inteligente</strong> - Recomendamos as melhores ofertas da campanha para cada cliente.
                </v-card-text>
                <v-card-text v-else> <strong class="confirm-bold">Padrão</strong> - Será enviada para todos os clientes </v-card-text>
                <v-card-title class="sub-title py-0"> Modo da campanha: </v-card-title>
                <v-card-text v-if="campanha.activatable">
                  <strong class="confirm-bold">Ativável</strong> - consumidores devem ativar pelo aplicativo
                </v-card-text>
                <v-card-text v-else> <strong class="confirm-bold">Não ativável</strong> - consumidores não precisam ativar pelo aplicativo </v-card-text>
              </v-card>

              <v-card v-if="campanha.industry && message" class="mb-2" min-height="340px">
                <mf-loading :boolean-loader="loading" loader-type="card" :color="'#969EA7'">
                  <v-card-title class="pb-0">
                    <b>Comunicação: </b>
                  </v-card-title>
                  <v-card-text> SMS </v-card-text>
                  <v-card-title class="sub-title py-0"> Mensagem: </v-card-title>
                  <v-card-text>
                    {{ message.text }}
                  </v-card-text>
                  <v-card-title class="sub-title py-0"> Data de envio: </v-card-title>
                  <v-card-text v-if="message.send_date && message.send_time">
                    {{ DateTime.fromISO(message.send_date).toFormat('dd/MM/yyyy') }} | {{ message.send_time }}
                  </v-card-text>
                  <v-card-text v-else>-</v-card-text>
                  <v-card-title class="sub-title py-0"> Custo: </v-card-title>
                  <v-card-text><strong class="confirm-bold">Campanha custeada pela indústria</strong></v-card-text>
                </mf-loading>
              </v-card>

              <v-card v-if="isMercapromo && hasPostCommunication(campanha)">
                <v-card-title class="pb-0">
                  <b>Comunicação pós-compra: </b>
                </v-card-title>
                <v-card-text>
                  <strong class="confirm-bold">{{ getPostCommunicationType(campanha) }}</strong>
                </v-card-text>
              </v-card>

              <mf-info-card v-bind="infoCardProps">
                <mf-progress-bar
                  v-if="timerTotalValue"
                  hide-percentage
                  hide-legend
                  :total-value="timerTotalValue"
                  :partial-value="timerPartialValue"
                  :description="timerLabel"
                  color="marca-0-l40"
                />
              </mf-info-card>
            </v-col>
          </v-row>

          <mf-action-buttons class="mt-2" :primary-button="primaryButton" :secondary-button="secondaryButton" />
        </div>
      </v-col>
    </v-row>

    <unavailable-products-dialog v-model="unavailableProductsDialog" :products="allSingleProducts" :unavailable-products="unavailableProducts" />
  </v-container>
</template>
<script>
import { mapState } from 'vuex'
import { DateTime } from 'luxon'
import { clearInterval } from 'timers'

import {
  QUERY_SMS_BY_CAMPAIGN_ID,
  SEND_FRANCHISEE_PRODUCTS_EANS_FREQUENCY_REPORT,
  QUERY_PRODUCTS_FRANCHISEE_PERCENTAGE,
  OFFER_SCHEDULE_UPDATE_SUBSCRIPTION,
} from '../../graphql'
import { wsClient } from '@/services/webSocket'

import ExportEmailReportDialog from '@/components/export-email-report/ExportEmailReportDialog.vue'
import DigitalVoucherTable from '@/modules/industria/ofertas-trade/views/components/DigitalVoucherTable.vue'
import CrossSellTable from '@/modules/industria/ofertas-trade/views/components/CrossSellTable.vue'
import { hasPostCommunication, getPostCommunicationType } from '@/modules/industria/helpers/postCommunication.js'
import intelligentDistributionMixin from '../mixins/intelligent-distribution.js'
import UnavailableProductsDialog from './UnavailableProductsDialog.vue'

export default {
  name: 'ConfirmOfferCampaign',
  components: {
    ConfirmCampaignOfferComboTable: () => import('./offer-combo/ConfirmCampaignOfferComboTable.vue'),
    RevisionContainer: () => import('./new-offer-sales-tables/RevisionContainer.vue'),
    ExportEmailReportDialog,
    DigitalVoucherTable,
    CrossSellTable,
    UnavailableProductsDialog,
  },
  mixins: [intelligentDistributionMixin],
  props: {
    campanha: {
      type: Object,
      required: true,
    },
    confirmCampaign: {
      type: Boolean,
      default: false,
    },
    offerSalesKeyNames: {
      type: Object,
      required: true,
    },
    eans: {
      type: Object,
      required: true,
    },
    timerTotalValue: {
      type: Number,
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isNewOffer: {
      type: Boolean,
      default: false,
    },
    newOfferScheduleIdToCompare: {
      type: String,
      default: '',
    },
    allSingleProducts: {
      type: Array,
      default: () => [],
    },
    cashbackExpiration: {
      type: Object,
      default: () => {},
    },
    unavailableProducts: {
      type: Array,
      default: () => {},
    },
  },
  data: () => ({
    units: [],
    partner_units: [],
    loading: false,
    DateTime: DateTime,
    message: null,
    fileFormat: '',
    loadingFranchiseeProducts: false,
    tooltipEditMercapromoStatus: 'Não é possível alterar o status do produto neste momento',
    unavailableProductsDialog: false,
    timerPartialValue: 0,
    errorOnSave: false,
    interval: null,
  }),
  computed: {
    ...mapState({
      stateDepartments: (state) => state.departments.departments,
    }),
    timerLabel() {
      const timeRemaining = this.timerTotalValue - this.timerPartialValue
      const seconds = timeRemaining === 1 ? 'segundo restante' : 'segundos restantes'
      return `${timeRemaining} ${seconds}`
    },
    automaticCampaign() {
      return Boolean(['erp'].includes(this.campanha?.origin))
    },
    franchiseeEansFrequencyPercentage() {
      const allPercentages = this.allSingleProducts.map((product) => product.franchisee_eans_frequency_percentage || 0)
      if (!allPercentages.length) return 0
      return allPercentages.reduce((total, current) => total + current, 0) / allPercentages.length
    },
    isFranchise() {
      return this.$getLoggedUser().is_franchise
    },
    getProductsPercentageColor() {
      if (this.franchiseeEansFrequencyPercentage <= 20) return '#FF0000'
      else if (this.franchiseeEansFrequencyPercentage > 20 && this.franchiseeEansFrequencyPercentage <= 40) return '#F39200'
      else if (this.franchiseeEansFrequencyPercentage > 40 && this.franchiseeEansFrequencyPercentage <= 60) return '#EFC941'
      else if (this.franchiseeEansFrequencyPercentage > 60 && this.franchiseeEansFrequencyPercentage <= 80) return '#0FC94D'
      return '#0A8533'
    },
    primaryButton() {
      const button = {
        text: 'Confirmar',
        action: () => this.$emit('save'),
        isVisible: true,
        isLoading: this.loading || this.isLoading,
        isDisabled: this.unavailableProducts?.length > 0,
      }

      if (this.errorOnSave) {
        if (this.isNewOffer) {
          button.action = () => this.$emit('save-draft')
          button.text = 'Salvar rascunho'
        } else {
          button.action = () => this.$emit('back-to-offers-list-skip')
          button.text = 'Sair sem salvar'
        }
      }

      return button
    },
    secondaryButton() {
      const button = {
        text: 'Voltar',
        action: () => this.$emit('update:confirmCampaign', false),
        isVisible: true,
        isDisabled: this.loading || this.isLoading,
      }

      if (this.errorOnSave) {
        if (this.isNewOffer) {
          button.text = 'Voltar'
        } else {
          button.isVisible = false
        }
      }

      return button
    },
    infoCardProps() {
      if (this.errorOnSave) {
        if (this.isNewOffer) {
          return {
            variant: 'error',
            icon: 'error',
            title: 'Falha na criação',
            description: 'Ocorreu algum erro no processamento dessa oferta, você pode  entrar em contato com o nosso suporte.',
          }
        } else {
          return {
            variant: 'error',
            icon: 'error',
            title: 'Falha na edição',
            description:
              'Ocorreu algum erro no processamento dessa oferta, as alterações realizadas não foram salvas e a campanha segue como estava. Tente alterar novamente mais tarde ou entre em contato com o suporte.',
          }
        }
      } else if (this.isIntelligentDistributionEnabled) {
        const totalConsumers = this.getTotalConsumers()
        const offersPerConsumer = this.offersPerConsumer
        const totalOffers = this.getTotalAvailableOffers()

        return {
          title: 'Campanha com IA',
          description: `Você está prestes a ativar uma campanha com geração de ofertas por IA.

          O sistema irá processar ${this.getConsumersText(totalConsumers)} do segmento selecionado e irá recomendar ${this.getOffersText(
            offersPerConsumer
          )} para cada um, com base ${this.getBasedOnText(totalOffers)}.

          As ofertas serão distribuídas de forma personalizada e assíncrona.`,
        }
      } else {
        if (this.timerTotalValue) {
          return {
            title: 'Preparando suas ofertas',
            description: this.isIntelligentDistributionEnabled
              ? 'Estamos preparando a sua campanha, a geração de ofertas por IA pode levar mais tempo de processamento. '
              : 'Estamos processando a sua campanha, permaneça nesta página para ver a confirmação.',
          }
        } else {
          return {
            title: 'Preparando suas ofertas',
            description:
              'Após aprovar a ação no botão "Confirmar", ela entrará no status "Processando" e pode levar alguns minutos até ser de fato ser inserida.',
          }
        }
      }
    },
    stateUnits() {
      return this.$store.getters.units
    },
    offerSalesTable() {
      return [
        ...(this.campanha?.offer_sales?.length > 0 ? ['offer_sales'] : []),
        ...(this.campanha?.percentage_offer_sales?.length > 0 ? ['percentage_offer_sales'] : []),
        ...(this.campanha?.dynamic_pricing_percentage_offer_sales?.length > 0 ? ['dynamic_pricing_percentage_offer_sales'] : []),
        ...(this.campanha?.takepay_offer_sales?.length > 0 ? ['takepay_offer_sales'] : []),
        ...(this.campanha?.cashback_percentage_offer_sales?.length > 0 ? ['cashback_percentage_offer_sales'] : []),
        ...(this.campanha?.cashback_absolute_offer_sales?.length > 0 ? ['cashback_absolute_offer_sales'] : []),
        ...(this.campanha?.points_offer_sales?.length > 0 ? ['points_offer_sales'] : []),
        ...(this.campanha?.next_buy_cashback_offer_sales?.length > 0 ? ['next_buy_cashback_offer_sales'] : []),
      ]
    },
    isMercapromo() {
      return Boolean(this.campanha?.industry?.is_mercapromo)
    },
    hasCashbackOffer() {
      return this.campanha?.cashback_percentage_offer_sales?.length > 0 || this.campanha?.cashback_absolute_offer_sales?.length > 0
    },
    cashbackOfferLabel() {
      if (!this.hasCashbackOffer) return ''
      if (this.cashbackExpiration?.type === 'BY_DATE') {
        const isIsoDate = DateTime.fromISO(this.cashbackExpiration?.expires_at)?.isValid
        const formattedDate = isIsoDate
          ? DateTime.fromISO(this.cashbackExpiration?.expires_at).toFormat('dd/MM/yyyy')
          : DateTime.fromFormat(this.cashbackExpiration?.expires_at, 'yyyy-MM-dd HH:mm:ss').toFormat('dd/MM/yyyy')
        return `Expiração em: <span><b>${formattedDate}</b></span>`
      } else {
        const expirationDaysLabel = this.cashbackExpiration?.expiration_in_days === 1 ? '1 dia' : `${this.cashbackExpiration?.expiration_in_days} dias`
        return `Expiração em <span><b>${expirationDaysLabel}</b> após <b>a obtenção do cashback</b></span>`
      }
    },
  },
  watch: {
    unavailableProducts: {
      deep: true,
      handler(newValue) {
        if (newValue.length) this.unavailableProductsDialog = true
      },
    },
    timerTotalValue: {
      handler(value) {
        if (value > 0) {
          this.initTimer()
        }
      },
    },
  },

  beforeUnmount() {
    clearInterval(this.interval)
  },

  async mounted() {
    await this.getData()
    this.filterUnits()
    if (this.isFranchise) await this.getFranchiseeData()
    await this.subscribeToOfferSchedule()
  },

  methods: {
    getPostCommunicationType,
    hasPostCommunication,

    initTimer() {
      this.interval = setInterval(() => {
        if (this.timerPartialValue < this.timerTotalValue) this.timerPartialValue++
      }, 1000)
    },
    async subscribeToOfferSchedule() {
      const self = this
      await wsClient.subscribe(
        {
          query: OFFER_SCHEDULE_UPDATE_SUBSCRIPTION,
          operationName: 'OffersScheduleUpdate',
        },
        {
          next({ data: { offersScheduleUpdate } }) {
            const { offerScheduleId, status } = offersScheduleUpdate
            if (status === 'SUCCESS' && offerScheduleId === self.newOfferScheduleIdToCompare) {
              self.$emit('subscription-finished')
              self.loading = false
            }
            if (status === 'ERROR' && offerScheduleId === self.newOfferScheduleIdToCompare) {
              self.$emit('subscription-error')
              self.errorOnSave = true
              self.loading = false
            }
          },
          error(error) {
            console.error(error)
            self.$emit('subscription-error')
            self.errorOnSave = true
            self.loading = false
          },
        }
      )
    },

    getFileFormat(value) {
      this.fileFormat = value
    },
    async exportReport(emails) {
      return this.$apollo.mutate({
        mutation: SEND_FRANCHISEE_PRODUCTS_EANS_FREQUENCY_REPORT,
        fetchPolicy: 'no-cache',
        variables: {
          units: this.campanha.units,
          eans: this.allSingleProducts.map((product) => product.sku),
          emails,
          fileFormat: this.fileFormat,
        },
        context: {
          uri: this.$microservicesUrls['asyncJobs'],
        },
      })
    },
    async getData() {
      try {
        if (!this.campanha.industry) return

        this.loading = true
        const response = await this.$apollo.query({
          query: QUERY_SMS_BY_CAMPAIGN_ID,
          context: {
            uri: this.$microservicesUrls['campaigns'],
          },
          variables: {
            id: this.campanha._id,
            mode: ['SMS'],
            isIndustry: Boolean(this.campanha.industry),
          },
          fetchPolicy: 'no-cache',
        })
        this.loading = false

        if (response.data && response.data.campaigns.campaigns.length > 0) {
          this.message = response.data.campaigns.campaigns[0].message
        }
      } catch (error) {
        this.$snackbar({ message: 'Erro ao buscar dados no servidor', snackbarColor: 'error' })
      }
    },

    async getFranchiseeData() {
      try {
        this.loadingFranchiseeProducts = true
        const {
          data: {
            products: { products },
          },
        } = await this.$apollo.query({
          query: QUERY_PRODUCTS_FRANCHISEE_PERCENTAGE,
          variables: {
            skus: this.allSingleProducts.map((item) => item.sku),
            units: this.campanha.units,
          },
          fetchPolicy: 'no-cache',
        })
        this.loadingFranchiseeProducts = false
        this.putPercentageInOfferSales(products)
      } catch (error) {
        this.$snackbar({ message: 'Erro ao buscar dados no servidor', snackbarColor: 'error' })
      }
    },

    putPercentageInOfferSales(products = []) {
      if (!products.length) return

      let skusToPercentage = {}
      for (let product of products) {
        skusToPercentage[product.sku] = product.franchisee_eans_frequency_percentage
      }

      Object.values(this.offerSalesKeyNames).forEach((offerSaleType) => {
        if (offerSaleType === 'combo_offer_sales') {
          this.campanha.combo_offer_sales = this.campanha.combo_offer_sales.map((combo) => {
            return {
              ...combo,
              target_products: combo.target_products.map((targetProduct) => {
                if (targetProduct.products && targetProduct.products.length) {
                  return {
                    ...targetProduct,
                    products: targetProduct.products.map((product) => {
                      return {
                        ...product,
                        franchisee_eans_frequency_percentage: skusToPercentage[product.sku],
                      }
                    }),
                  }
                } else {
                  return {
                    ...targetProduct,
                    franchisee_eans_frequency_percentage: skusToPercentage[targetProduct.sku],
                  }
                }
              }),
              trigger_products: combo.trigger_products.map((triggerProduct) => {
                if (triggerProduct.products && triggerProduct.products.length) {
                  return {
                    ...triggerProduct,
                    products: triggerProduct.products.map((product) => {
                      return {
                        ...product,
                        franchisee_eans_frequency_percentage: skusToPercentage[product.sku],
                      }
                    }),
                  }
                } else {
                  return {
                    ...triggerProduct,
                    franchisee_eans_frequency_percentage: skusToPercentage[triggerProduct.sku],
                  }
                }
              }),
            }
          })
        } else {
          this.putProductsInOfferSale(offerSaleType, skusToPercentage)
        }
      })
    },

    putProductsInOfferSale(offerSaleType, skusToPercentage) {
      if (this.campanha[offerSaleType] && this.campanha[offerSaleType].length > 0) {
        this.campanha[offerSaleType] = this.campanha[offerSaleType].map((productOrGroup) => {
          if (productOrGroup.products && productOrGroup.products.length > 0) {
            return {
              ...productOrGroup,
              products: productOrGroup.products.map((product) => {
                return {
                  ...product,
                  franchisee_eans_frequency_percentage: skusToPercentage[product.sku],
                }
              }),
            }
          } else {
            return {
              ...productOrGroup,
              franchisee_eans_frequency_percentage: skusToPercentage[productOrGroup.sku],
            }
          }
        })
      }
    },

    filterUnits() {
      this.units = this.stateUnits
        .filter((unit) => {
          if (this.campanha.units.includes(unit.id_erp)) {
            return unit
          }
        })
        .map((unit) => {
          return {
            id: unit.id_erp,
            name: unit.name,
            partner_unit_id: unit.ecommerce_partner?.partner_unit_id,
          }
        })
    },
    formatToBRL(price) {
      return price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    getTotalConsumers() {
      const totalClients = this.campanha.segments.reduce((total, segment) => {
        return total + (segment.clients_qty || 0)
      }, 0)

      return totalClients.toLocaleString('pt-BR')
    },
    getTotalAvailableOffers() {
      let total = 0

      if (this.campanha) {
        const offerTypes = [
          'offer_sales',
          'percentage_offer_sales',
          'dynamic_pricing_percentage_offer_sales',
          'takepay_offer_sales',
          'combo_offer_sales',
          'cashback_percentage_offer_sales',
          'cashback_absolute_offer_sales',
          'points_offer_sales',
          'next_buy_cashback_offer_sales',
          'dynamic_rule_offer_sales',
          'cross_sell_offer_sales',
        ]

        offerTypes.forEach((type) => {
          if (this.campanha[type] && Array.isArray(this.campanha[type])) {
            this.campanha[type].forEach((offer) => {
              if (offer.isGroup && offer.products && Array.isArray(offer.products)) {
                if (offer.group_rules_exhibition === 'PUBLIC') {
                  const hasActiveProducts = offer.products.some((product) => product.active)
                  if (hasActiveProducts) {
                    total += 1
                  }
                } else {
                  offer.products.forEach((product) => {
                    if (product.active) {
                      total += 1
                    }
                  })
                }
              } else if (offer.active) {
                total += 1
              }
            })
          }
        })
      }

      return total
    },
    getConsumersText(count) {
      const numericCount = parseInt(count.replace(/\./g, ''), 10)
      return numericCount === 1 ? 'o consumidor' : `os ${count} consumidores`
    },
    getOffersText(count) {
      return count === 1 ? 'a melhor oferta' : `as ${count} melhores ofertas`
    },
    getBasedOnText(count) {
      return count === 1 ? 'na oferta que você configurou' : `nas ${count} ofertas que você configurou`
    },
  },
}
</script>

<style lang="scss">
.custom-progress-bar {
  max-width: 340px;
  flex: 1;
  .loading-bar {
    height: 28px !important;
    border-radius: 16px !important;
    .progress-bar {
      height: 28px !important;
      border-radius: 16px !important;
    }
  }

  p {
    font-size: 16px;
    font-weight: bold;
  }
}
.confirm-offer-campaign {
  .confirm-bold {
    color: $marca-1;
  }

  .offer_sales-offer-confirm {
    max-height: 70vh;
    overflow: auto;
  }

  .v-card__text,
  .v-card__title {
    word-break: normal !important;
  }

  .empty-value {
    color: #e58a02;
  }
}

.sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 68px;
  z-index: 2;
}

.cashback-expiration-container {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid $cinza-l50;

  h2 {
    font-size: 18px;
    font-weight: 700;
    color: $cinza-d10;
  }

  p {
    margin: 8px 0 0;
    color: $cinza-0;
    font-size: 14px;

    span {
      color: $marca-0-l20 !important;
    }
  }
}
</style>
